export default "__VITE_ASSET__CgOWM601__"